import { Button } from '@/components/ui/button'
import { Card } from '@/components/ui/card'
import { FloatingInput } from '@/components/ui/floating-input'
import { useToast } from '@/hooks/use-toast'
import { apiFetch } from '@/utils'
import { useState } from 'react'
import { useLocation } from 'wouter'

export default function ForgotPasswordPage() {
    const [email, setEmail] = useState('')

    const { toast } = useToast()
    const [, navigate] = useLocation()

    const [isSending, setIsSending] = useState(false)

    const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setEmail(e.target.value)
    }

    const onSubmit = async () => {
        setIsSending(true)
        try {
            const response = await apiFetch('/v1/users/password-reset', {
                method: 'POST',
                body: JSON.stringify({ email }),
            });

            const result = await response.json();

            if (!result.success) {
                toast({
                    title: 'Error',
                    description: `Failed to send password reset email: ${result.error.message}`,
                    variant: 'destructive'
                })
            } else {
                toast({
                    title: 'Success',
                    description: 'Password reset link sent to your email'
                })
            }


        } catch (error: any) {
            console.error('Error sending password reset email:', error)
            toast({
                title: 'Failed to send password reset email',
                description: error.message,
                variant: 'destructive'
            })
        }
        setIsSending(false)
    }

    return (
        <div className="min-h-screen bg-[#18181B] flex items-center justify-center">
            <div className="container max-w-lg mx-auto p-4">
                <Card className="p-6 flex flex-col gap-4 items-center bg-[#3C3C3C] border-0">
                    <div className="text-center mb-4">
                        <h1 className="text-2xl font-bold text-[#ffffff]">Forgot Password</h1>
                        <p className="text-sm text-[#BABABB] mt-4">
                            Enter the email address connected to your account, and we'll send
                            you instructions to reset your password.
                        </p>
                    </div>

                    <FloatingInput
                        type="email"
                        autoComplete="email"
                        label="Email"
                        className="w-full"
                        onChange={handleEmailChange}
                    />
                    <Button onClick={onSubmit} className="w-full bg-[#EF4444] hover:bg-[#DC2626] text-white" disabled={isSending}>
                        Send Reset Link
                    </Button>

                    <div className="mt-4 text-center space-y-2">
                        <p className="text-sm text-[#BABABB]">
                            Remember your password?{' '}
                            <Button
                                variant="link"
                                className="p-0 h-auto font-semibold text-[#EF4444] hover:text-[#DC2626]"
                                onClick={() => navigate('/login')}>
                                Log in
                            </Button>
                        </p>
                    </div>
                </Card>
            </div>
        </div>
    )
}
